import { render, staticRenderFns } from "./DashboardAir.vue?vue&type=template&id=587b156d&scoped=true&"
import script from "./DashboardAir.vue?vue&type=script&lang=js&"
export * from "./DashboardAir.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAir.vue?vue&type=style&index=0&id=587b156d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b156d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
